import "./pull-quote.scss";

import cn from "clsx";

import { Link } from "design-system/components/primitives/link/link";
import { MediaAsset } from "design-system/components/primitives/media-asset/media-asset";
import { PersonTeaseProps } from "design-system/components/primitives/person-tease/person-tease";
import { Alignment, EditAttributes } from "design-system/types/types";
import { Theme } from "design-system/utils/theme";
import { ReactNode } from "react";

export interface PullQuoteProps {
  align?: Alignment;
  quote?: ReactNode;
  theme?: Theme;
  attribution?: PersonTeaseProps;
  hideQuoteMarks?: boolean;
  className?: string;
  editAttributes?: {
    quote?: EditAttributes;
    attribution?: EditAttributes;
  };
}

export function PullQuote({
  align,
  quote,
  theme,
  attribution,
  hideQuoteMarks,
  className,
  editAttributes,
}: PullQuoteProps) {
  const wrapperClass = cn(
    align && `hbs-global-align-${align}`,
    "hbs-component--pull-quote",
  );

  const titles = attribution?.titles || [];
  const themedClassname = cn(
    theme ? `hbs-pullquote--themed${align === "wide" ? "__wide" : ""}` : "",
    "hbs-pullquote",
  );

  return (
    <div className={cn(wrapperClass, className)} data-theme={theme}>
      <div className="hbs-pullquote__content">
        <blockquote className={themedClassname}>
          <div
            className={cn(`hbs-pullquote__text`, hideQuoteMarks && `hidequote`)}
            {...editAttributes?.quote}
          >
            {quote}
          </div>

          {attribution && (
            <div
              className="hbs-pull-quote__attribution"
              {...editAttributes?.attribution}
            >
              <MediaAsset image={attribution.portrait} />
              <span>
                {attribution.link ? (
                  <Link href={attribution.link}>{attribution.name}</Link>
                ) : (
                  attribution.name
                )}
                {titles.length > 0 && <span>{`; ${titles.join(", ")}`}</span>}
              </span>
            </div>
          )}
        </blockquote>
      </div>
    </div>
  );
}
